import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const EmailSignup = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/subscribers", { email });
      toast.success(data.already ? "You're already on the list! 🍊" : "You're in! Fresh drops coming your way 🥤");
      if (!data.already) setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please enter a valid email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative py-16 sm:py-24" data-testid="email-signup-section">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-[32px] bg-[#1A1A1A] p-8 sm:p-14 text-center relative overflow-hidden"
        >
          <div className="absolute -top-14 -left-10 w-48 h-48 rounded-full bg-[#FF7A1A]/30 blur-2xl" />
          <div className="absolute -bottom-14 -right-10 w-48 h-48 rounded-full bg-[#7ED321]/30 blur-2xl" />
          <div className="relative z-10">
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-white">
              Never miss a <span className="text-[#FFC93C]">fresh drop</span>
            </h2>
            <p className="mt-3 text-white/70 max-w-md mx-auto">Get first dibs on new flavors and weekly menus. One email, zero spam.</p>

            <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="flex-1 rounded-full bg-white/95 px-6 py-4 text-[#1A1A1A] font-medium outline-none focus:ring-4 focus:ring-[#FFC93C]/50 placeholder:text-[#1A1A1A]/40"
                data-testid="signup-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="rounded-full bg-[#FF7A1A] hover:bg-[#FFC93C] hover:text-[#1A1A1A] text-white font-bold px-8 py-4 transition-all duration-300 shadow-[0_8px_25px_rgba(255,122,26,0.4)] active:scale-95 disabled:opacity-60"
                data-testid="signup-submit-btn"
              >
                {loading ? "Joining…" : "Sign me up"}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EmailSignup;
